import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-spec-dividenduitkeringen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-spec-dividenduitkeringen.component.html',
  styleUrl: './tekst-spec-dividenduitkeringen.component.scss',
})
export class TekstSpecDividenduitkeringenComponent {}
